import React from 'react';
import PropTypes from 'prop-types';
import IconWithText from '../Icons/IconWithText';
import Button from '../Buttons/Button';

const AddToFolderButton = ({ onClick, iconFill }) => (
  <Button onClick={onClick} faux>
    <IconWithText name="folder" size="m" fill={iconFill}>Folder +</IconWithText>
  </Button>
);

AddToFolderButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  iconFill: PropTypes.string,
};

export default AddToFolderButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Buttons/AddToFolderButton.js